// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__AQbg5","desktopLogo":"Logo_desktopLogo__8Ftb5","mobileLogo":"Logo_mobileLogo__SSwrf","wordmark":"Logo_wordmark__gnV-U","mark":"Logo_mark__FftOy"};